import { isFunction, isNode } from '../utils'
import { getCacheName, getContentType } from '../process'
import { DEF_CONST } from '../enum'

export function setPreload(url, option, config) {
  // 只在用户端缓存
  if (isNode) {
    return
  }
  // 如果未设置缓存，则不缓存
  if (!config.preload) {
    return
  }
  // 只支持 json 格式的预加载
  const contentType = getContentType(option, config, DEF_CONST.method.GET)
  if (contentType !== DEF_CONST.contentType.JSON) {
    return
  }

  try {
    const cacheName = getCacheName(option, config)
    const meta = typeof config.preload === 'object' ? config.preload : {}
    let cacheUrl = url
    let store = localStorage.getItem(cacheName)
    if (store) {
      store = JSON.parse(store)
    } else {
      store = []
    }

    if (meta.queryMap) {
      const search = {}
      const temp = cacheUrl.split('?')
      temp[1]
        .split('&')
        .map((_) => _.split('='))
        .forEach((pair) => {
          search[pair[0]] = pair[1]
        })

      Object.keys(meta.queryMap).forEach((key) => {
        delete search[key]
      })

      cacheUrl = `${temp[0]}?`
      Object.keys(search).forEach((key) => {
        cacheUrl += `${key}=${search[key]}&`
      })
      cacheUrl = cacheUrl.substr(0, cacheUrl.length - 1)
    }

    store.push({ url: cacheUrl, meta })

    localStorage.setItem(cacheName, JSON.stringify(store))
  } catch (e) {
    // do nothing
  }
}

export async function getPreload(url, option, config) {
  // 只在用户端缓存
  if (isNode) {
    return
  }
  // 如果未设置缓存，则不缓存
  if (!config.preload) {
    return
  }
  // 只支持 json 格式的预加载
  const contentType = getContentType(option, config, DEF_CONST.method.GET)
  if (contentType !== DEF_CONST.contentType.JSON) {
    return
  }

  const preload = window.__requestPreload || {}
  if (!preload[encodeURIComponent(url)]) {
    return
  }

  let response = preload[encodeURIComponent(url)]
  if (typeof response === 'object' && typeof response.then === 'function') {
    try {
      response = await response
    } catch (e) {
      return
    }
  }

  preload[encodeURIComponent(url)] = undefined
  if (!response.ok || response.status !== 200) {
    return
  }

  try {
    let jsonData = await response.json()
    const headers = {}
    for (const p of response.headers) {
      headers[p[0]] = p[1]
    }

    if (isFunction(option.onSuccess)) {
      jsonData =
        option.onSuccess({
          url,
          method: DEF_CONST.method.GET.toLowerCase(),
          status: response.status,
          config: { headers },
          data: jsonData
        }) || jsonData
    }

    return jsonData
  } catch (e) {
    // do nothing
  }
}
